export const trimAddress = (addr) => {
  return `${addr.substring(0, 6) }...${addr.substring(addr.length - 4)}`;
}

export const socialLinks = [
  // {
  //   name : "facebook",
  //   image : "fa-brands fa-facebook-square fa-2x i-color",
  //   link : "https://www.facebook.com/bnbclassicofficial/"
  // },
  {
    name : "twitter",
    image : "fa-brands fa-twitter fa-2x i-color",
    link : "https://twitter.com/classic_bnb?t=nepFFzw8piEjivod6MkyWg&s=09/"
  },
  // {
  //   name : "youtube",
  //   image : "fa-brands fa-youtube fa-2x i-color",
  //   link : "https://www.youtube.com/channel/UCnzs9zOPCv6-M12ARayj9bA/featured"
  // },
  {
    name : "telegram",
    image : "fa-brands fa-telegram fa-2x i-color",
    link : "https://t.me/+zKJVcSMDnMpmNjE0"
  },
  {
    name : "telegram",
    image : "fa-brands fa-telegram fa-2x i-color",
    link : "https://t.me/+bmG_6lF_nL83YTg8"
  },
  // {
  //   name : "github",
  //   image : "fa-brands fa-github fa-2x i-color",
  //   link : "https://github.com/Bnbclassic"
  // }
]
  


